
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";

const PowerPointToCanva = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/PowerPointToCanva"
        ogImage="/images/ppt2canva-og-image.jpg"
      />

      <MagicianSection
        title={t("page/PowerPointToCanva:title")}
        subtitle={t("page/PowerPointToCanva:subtitle")}
        magicianLogoFile="canva"
        cta={{
          title: t("section/magicians:scrollTo"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/PowerPointToCanva:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/PowerPointToCanva:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/powerpoint-to-canva-example.png",
          alt: "PowerPoint to Canva Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/PowerPointToCanva:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/powerpoint-to-canva-converted-file-elements.jpg",
          alt: t("page/PowerPointToCanva:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/PowerPointToCanva:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/PowerPointToCanva:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/PowerPointToCanva:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/PowerPointToCanva:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/PowerPointToCanva:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-CIRCLED-EMPTY",
            title: t(
              "page/PowerPointToCanva:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/PowerPointToCanva:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("page/PowerPointToCanva:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t(
              "page/PowerPointToCanva:section/conversion.badges.supportsAll",
            ),
          },
          {
            iconType: "SYNC-ICON",
            text: t("page/PowerPointToCanva:section/conversion.badges.allPath"),
          },
          {
            iconType: "SYNC-ICON",
            text: t(
              "page/PowerPointToCanva:section/conversion.badges.fullArtboard",
            ),
          },
        ]}
        elements={{
          from: {
            iconType: "POWERPOINT",
            image: "/images/powerpoint-preview.jpg",
            title: "Powerpoint Demo Preview",
          },
          to: {
            iconType: "CANVA",
            image: "/images/canva-preview-slides-new.png",
            title: "Canva Import Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.powerpointToCanvaPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PowerPointToCanva;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/powerpoint-to-canva',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  